export enum StatsElementContentBlock {
  Root = 'StatsElementContent',
}
